import {
  matchPath,
  useMatch,
  useResolvedPath,
} from 'react-router-dom-v5-compat'

/**
 * This hook checks if the current path or the 'parent' path matches the given
 * path. This is necessary because of how some routes are nested to show modals
 * (See AppPages/index.tsx).
 *
 * Specifically, there's a bug where showing the post modal over the calendar
 * would cause a bunch of the `useMatch` below to no longer match, and this
 * would cause the componenet to re-render and look off.
 *
 * To fix this, we also check if the parent path matches, using the handy
 * useResolvedPath and matchPath methods from React Router 6.
 *
 * @param path - The path to check against.
 * @returns True if the current path or the parent path matches the given path,
 * false otherwise.
 */
function useMatchCurrentOrParentPath(path: string): boolean {
  const parentPath = useResolvedPath('.')
  const matchOnCurrentPath = useMatch(path)
  const matchOnParentPath = matchPath(path, parentPath.pathname)
  return !!matchOnCurrentPath || !!matchOnParentPath
}

export default useMatchCurrentOrParentPath
